export { type Activity, type CheckItem, type ChecksRecord, type FileData, type Task,type WorkshopUpdateRequest, type WorkshopVerificationRequest } from 'api/types';

export const VerificationStatus = {
  STEP_1_SUBMITTED: 100,
  STEP_2_SUBMITTED: 150,
  STEP_1_REVIEW: 200,
  STEP_2_REVIEW: 250,
  WAITING_ON_POA: 400,
  CLARIFICATION_STEP_1: 500,
  CLARIFICATION_STEP_2: 550,
  COMPLETED: 700,
  REJECTED: 900,
} as const;

export type VerificationStatusValue = (typeof VerificationStatus)[keyof typeof VerificationStatus];

export type DocumentType = 'identification' | 'business_licence' | 'power_of_attorney' | 'handwerkskarte';

export const NOT_READABLE_KEY = 'not_readable';

export type VerificationStep = 'step1' | 'step2';

export type DocumentUpdateParams = {
  identification_valid?: boolean;
  identification_errors?: string[];
  business_licence_valid?: boolean;
  business_licence_errors?: string[];
  power_of_attorney_valid?: boolean;
  power_of_attorney_errors?: string[];
  power_of_attorney_uuid?: string;
  identification_uuid?: string;
  business_licence_uuid?: string;
  files_update_reason?: string;
};
